module.exports = __webpack_public_path__ + "img/workerCode250212.44451160.png";